/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import { IS_DEV, ROOT_STORAGE_WEB } from 'helpers/config'

interface ServerImageProps {
    src: string
    className?: string
    alt: string
}

export const ServerImage = (props: ServerImageProps) => {
    let src = props.src
    if (!src) {
        return (
            <img
                alt={'No image'}
                className={
                    props.className
                        ? props.className
                        : 'w-full h-full object-cover'
                }
                src={''}
            />
        )
    }

    const alternatePicture = props.src.includes('winti.tomkart.com')
    const replacePictureUrl = (src: string) => {
        switch (src) {
            case 'https://winti.tomkart.com/svg/adult-helmet.svg':
                return IS_DEV
                    ? 'https://booking.kart.ch/assets/images/Blue-Racing-Helmet.png'
                    : '/assets/images/Blue-Racing-Helmet.png'
            case 'https://winti.tomkart.com/svg/child-helmet.svg':
                return IS_DEV
                    ? 'https://booking.kart.ch/assets/images/Green-Racing-Helmet.png'
                    : '/assets/images/Green-Racing-Helmet.png'
            default:
                return IS_DEV
                    ? 'https://booking.kart.ch/assets/images/Blue-Racing-Helmet.png'
                    : '/assets/images/Blue-Racing-Helmet.png'
        }
    }

    if (typeof src === 'string') {
        if (
            src.indexOf('https:') === -1 &&
            src.indexOf('/assets/images/') === -1
        ) {
            src = ROOT_STORAGE_WEB + 'storage' + src
        }
    }

    const dev_image = (src) => {
        return src.includes('https://') ? src : IS_DEV ? '' + src : src
    }

    return (
        <img
            alt={props.alt}
            className={
                props.className ? props.className : 'w-full h-full object-cover'
            }
            src={alternatePicture ? replacePictureUrl(src) : dev_image(src)}
        />
    )
}
